import { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from 'apiConfig';
import { useAppInfo } from 'AppState';

const useDeleteWatchlist = () => {
  const {stateApp} = useAppInfo()
  const userId = stateApp.userId
  
  const [error, setError] = useState(null);
  
  const deleteWatchlist = async (watchlistSelected) => {
    try {
      const response = await axios.post(`${BASE_URL}/deleteWatchlist/`, {
        userId,
        watchlistName:watchlistSelected,
      });

      setError("Success")
    } catch (err) {
      setError('Error deleting Watchlist data');
    }
  };

  return { deleteWatchlist, error };
};

export default useDeleteWatchlist;